import { DeviceMetrics, GaugeType } from "model/Metric"

interface AlertStatsResponse {
  count: number;
  devices: {
    count: number;
    absolute: number;
  } 
}

interface DeviceStatusResponse {
  total: number;
  alerts?: {
    critical: AlertStatsResponse;
    warning:  AlertStatsResponse;
    info:     AlertStatsResponse;
  }
}

interface DevicesGlobalStatsResponse {
  total: number;
  online: DeviceStatusResponse;
  offline: DeviceStatusResponse;
}

export interface UserStatsResponse {
  devices: DevicesGlobalStatsResponse;
}

export function responseToMetrics(response: UserStatsResponse): DeviceMetrics {
  const healthyCount = (
    response.devices.total -
    response.devices.offline.total -
    (response.devices.online.alerts?.critical.devices.absolute || 0) -
    (response.devices.online.alerts?.warning.devices.absolute  || 0)
  );
  return {
    gauges: [
      {
        type: GaugeType.CRITICAL,
        count: response.devices.online.alerts?.critical.count || 0,
        percentage: response.devices.total !== 0 ? Math.round(((response.devices.online.alerts?.critical.devices.absolute || 0) * 100) / response.devices.total) : 0
      },
      {
        type: GaugeType.WARNING,
        count: response.devices.online.alerts?.warning.count || 0,
        percentage: response.devices.total !== 0 ? Math.round(((response.devices.online.alerts?.warning.devices.absolute || 0) * 100) / response.devices.total) : 0
      },
      {
        type: GaugeType.HEALTHY,
        count: healthyCount,
        percentage: response.devices.total !== 0 ? Math.round((healthyCount * 100) / response.devices.total) : 0
      },
      {
        type: GaugeType.OFFLINE,
        count: response.devices.offline.total,
        percentage: response.devices.total !== 0 ? Math.round(((response.devices.offline.total || 0) * 100) / response.devices.total) : 0
      }
    ]
  }
}